/**
 * Amenity API service
 */
import axios from 'axios';
import { getApiConfig } from '../utils/apiUtils';

const API_BASE = '/configuration/api/amenities';

/**
 * Fetch all amenities grouped by category
 */
export const fetchAllAmenities = async () => {
  const response = await axios.get(`${API_BASE}/`, getApiConfig());
  return response.data;
};

/**
 * Fetch amenities for a specific category
 */
export const fetchAmenitiesByCategory = async (category) => {
  const response = await axios.get(`${API_BASE}/?category=${category}`, getApiConfig());
  return response.data;
};

/**
 * Create a new amenity
 */
export const createAmenity = async (amenityData) => {
  const response = await axios.post(`${API_BASE}/`, amenityData, getApiConfig());
  return response.data;
};

/**
 * Update an existing amenity
 */
export const updateAmenity = async (amenityId, amenityData) => {
  const response = await axios.put(`${API_BASE}/${amenityId}/`, amenityData, getApiConfig());
  return response.data;
};

/**
 * Delete an amenity (soft delete)
 */
export const deleteAmenity = async (amenityId) => {
  const response = await axios.delete(`${API_BASE}/${amenityId}/`, getApiConfig());
  return response.data;
};

